import React from 'react';

const formatCustomDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const strTime = hours.toString().padStart(2, '0') + ' ' + minutes + ' ' + ampm;
    return `${month} ${day}, ${year} ${strTime}`;
};

const formatKey = (key) => {
    if (key.toLowerCase() === 't' || key === 'createdAt') return 'Created At';
    let formatted = key.replace(/_id$/, '').replace(/Id$/, '');
    formatted = formatted.replace(/_/g, ' ');
    formatted = formatted.replace(/([A-Z])/g, ' $1');
    return formatted.trim().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

const renderValue = (value, key) => {
    if (key && (key.toLowerCase() === 't' || key === 'createdAt')) {
        return formatCustomDate(value);
    }
    if (typeof value === 'object' && value !== null) {
        if (value.title) return value.title;
        if (value.name) return value.name;
        return JSON.stringify(value);
    }
    return String(value);
};

const getFilteredEntries = (modalData) => {
    if (!modalData) return [];
    return Object.entries(modalData).filter(([key, value]) => {
        if (key === '__v' || key === '_id' || key === 'id') return false;
        if (key.endsWith('_id')) {
            const baseKey = key.replace(/_id$/, '');
            if (modalData[baseKey] !== undefined) return false;
        }
        if (key.endsWith('Id')) {
            const baseKey = key.replace(/Id$/, '');
            if (modalData[baseKey] !== undefined) return false;
        }
        return true;
    });
};

const DetailModal = ({ show, onHide, title, data, loading, customAction }) => {
    if (!show) return null;

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" onClick={onHide}></button>
                    </div>
                    <div className="modal-body">
                        {loading ? (
                            <div className="text-center my-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : data ? (
                            <table className="table table-bordered">
                                <tbody>
                                    {getFilteredEntries(data).map(([key, value]) => (
                                        <tr key={key}>
                                            <td style={{ width: '30%', fontWeight: 'bold' }}>{formatKey(key)}</td>
                                            <td style={{ wordBreak: 'break-all' }}>{renderValue(value, key)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center">No details available</div>
                        )}
                    </div>
                    <div className="modal-footer">
                        {customAction}
                        <button type="button" className="btn btn-danger light" onClick={onHide}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailModal;
